import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { Link } from "react-router-dom";
import { ASSETS } from "./assets";

const LINKS = [
  { label: "Le produit", href: "/#produit", id: "produit" },
  { label: "Comment ça marche", href: "/#process", id: "process" },
  { label: "Cas d'usage", href: "/#cas-usage", id: "cas-usage" },
  { label: "Caractéristiques", href: "/#specs", id: "specs" },
];

function Brand({ dark = false }) {
  return (
    <Link data-testid="navbar-logo" to="/" className="flex items-center gap-2.5 group">
      <span className="grid h-9 w-9 place-items-center bg-white rounded-sm border border-zinc-200 overflow-hidden">
        <img src={ASSETS.logo} alt="Logo Sapeur-360 KRX" className="h-full w-full object-contain p-0.5" />
      </span>
      <span className={`font-display text-xl font-extrabold tracking-tight ${dark ? "text-white" : "text-[#0A0A0A]"}`}>
        Sapeur<span className="text-[#E63946]">-360</span>
      </span>
    </Link>
  );
}

export { Brand };

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-white/85 backdrop-blur-md border-b border-zinc-200" : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="flex h-16 items-center justify-between">
          <Brand />

          <nav className="hidden md:flex items-center gap-8">
            {LINKS.map((l) => (
              <a
                key={l.href}
                data-testid={`nav-link-${l.id}`}
                href={l.href}
                className="text-sm font-semibold text-[#52525B] hover:text-[#0A0A0A] transition-colors duration-200"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <a
              data-testid="nav-demo-button"
              href="#contact"
              className="inline-flex items-center bg-[#E63946] hover:bg-[#BE123C] text-white text-sm font-bold px-5 py-2.5 rounded-sm transition-colors duration-300"
            >
              Demander une démo
            </a>
          </div>

          <button
            data-testid="nav-mobile-toggle"
            onClick={() => setOpen((v) => !v)}
            className="md:hidden grid h-10 w-10 place-items-center text-[#0A0A0A]"
            aria-label="Menu"
          >
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div data-testid="nav-mobile-menu" className="md:hidden bg-white border-b border-zinc-200">
          <div className="px-5 py-4 flex flex-col gap-1">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="py-2.5 text-base font-semibold text-[#52525B] hover:text-[#0A0A0A]"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="mt-2 text-center bg-[#E63946] text-white font-bold px-5 py-3 rounded-sm"
            >
              Demander une démo
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
